<template>
  <v-layout
    column
    class="pt-3 px-3"
    :class="backgroundClass"
  >
    <v-layout
      align-center
      wrap
      class="rangefield-thumb-handle-overflow-fix"
    >
      <span
        v-if="field.data.label && !noLabel"
        class="field-label grow-1"
      >{{
        field.data.label
      }}</span>
      <v-btn
        v-if="field.data.number_input && !rangefieldAsNumberInput"
        icon
        class="mr-0"
        :title="$t('templateDataRangeFieldEditMode_1')"
        @click="showRangeFieldAsNumberInput()"
      >
        <v-icon
          color="msr"
          small
        >
          edit
        </v-icon>
      </v-btn>
      <v-btn
        v-if="field.data.number_input && rangefieldAsNumberInput"
        icon
        class="mr-0"
        :title="$t('templateDataRangeFieldEditMode_2')"
        @click="showRangeFieldAsSlider()"
      >
        <v-icon
          small
          color="msr"
        >
          linear_scale
        </v-icon>
      </v-btn>
    </v-layout>
    <v-slider
      v-if="!rangefieldAsNumberInput"
      :value="value"
      :placeholder="field.data.placeholder"
      :required="field.required"
      :max="field.schema.maximum"
      :min="field.schema.minimum"
      :step="field.schema.multipleOf"
      :append-icon="
        field.data.buttons === false || !rangeFieldButtonStepSize ? null : 'add'
      "
      :prepend-icon="
        field.data.buttons === false || !rangeFieldButtonStepSize
          ? null
          : 'remove'
      "
      :thumb-label="
        field.data.thumb_handle === undefined ? true : field.data.thumb_handle
      "
      :style="field.data.css ? field.data.css.field : null"
      data-cy="overlay-data-rangefield"
      @input="onValueChanged"
      @click:append="onRangeFieldAppendButtonClicked"
      @click:prepend="onRangeFieldPrependButtonClicked"
    />
    <v-text-field
      v-else
      ref="rangefieldnumberinput"
      :value="value"
      box
      type="number"
      :rules="field.rules"
      :step="field.schema.multipleOf"
      solo
      data-cy="overlay-data-rangefield"
      @input="onValueChanged"
    />
  </v-layout>
</template>

<script>
import {OverlayOptionsField} from '@/mixins/overlayOptions.js';

export default {
  props: {
    field: {
      type: OverlayOptionsField,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    backgroundClass: {
      type: String,
      default: 'overlay-options-field-bg',
    },
  },
  data() {
    return {
      rangefieldAsNumberInput: false,
    };
  },
  computed: {
    rangeFieldButtonStepSize() {
      if (
        !this.field ||
        !this.field.schema ||
        this.field.schema.minimum === undefined ||
        this.field.schema.maximum === undefined
      ) {
        return 0;
      }
      const diff = this.field.schema.maximum - this.field.schema.minimum;
      return Math.ceil(diff / 4);
    },
  },
  methods: {
    onRangeFieldAppendButtonClicked() {
      this.onValueChanged(this.value + this.rangeFieldButtonStepSize);
    },
    onRangeFieldPrependButtonClicked() {
      this.onValueChanged(this.value - this.rangeFieldButtonStepSize);
    },
    showRangeFieldAsNumberInput() {
      this.rangefieldAsNumberInput = true;
      this.$nextTick(() => {
        this.$refs.rangefieldnumberinput.focus();
      });
    },
    showRangeFieldAsSlider() {
      this.rangefieldAsNumberInput = false;
    },
    onValueChanged(value) {
      // Limit to min/max.
      if (
        this.field.schema.maximum !== undefined &&
        value > this.field.schema.maximum
      ) {
        value = this.field.schema.maximum;
      }
      if (
        this.field.schema.minimum !== undefined &&
        value < this.field.schema.minimum
      ) {
        value = this.field.schema.minimum;
      }

      this.$emit('update:value', value);
    },
  },
};
</script>

<style scoped>
.field-label {
  font-size: 12px;
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.54);
}

.rangefield-thumb-handle-overflow-fix {
  width: calc(100% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/components/OverlayDataRangeField.vue